import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login').then((m) => m.Login),
  },
  {
    path: 'sessione-scaduta',
    loadComponent: () => import('./features/auth/auth-notice').then((m) => m.SessionExpired),
  },
  {
    path: 'errore-servizio',
    loadComponent: () => import('./features/auth/auth-notice').then((m) => m.ServiceError),
  },
  {
    path: '',
    loadComponent: () => import('./features/shell/shell').then((m) => m.Shell),
    canActivate: [authGuard],
    children: [
      {
        path: 'utenti',
        loadComponent: () => import('./features/accounts/accounts').then((m) => m.Accounts),
      },
      {
        path: 'gruppi',
        loadComponent: () => import('./features/groups/groups').then((m) => m.Groups),
      },
      {
        path: 'client',
        loadComponent: () => import('./features/clients/clients').then((m) => m.Clients),
      },
      {
        path: 'richieste',
        loadComponent: () =>
          import('./features/access-requests/access-requests').then((m) => m.AccessRequests),
      },
      { path: '', pathMatch: 'full', redirectTo: 'utenti' },
    ],
  },
  { path: '**', redirectTo: '' },
];
